import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
import API from "../../../api/axios"

function* loginUser({ payload: { user, history, callback } }) {
  try {
    // Login
    const response = yield call(
   API.post, "/users/auth/login",
      user,
    )
    const { token } = response.data

    // Save token
    localStorage.setItem("authToken", token)

    // Store email from payload (fallback)
    if (user?.email) {
      localStorage.setItem("email", user.email)
    } else {
      console.warn(" No email found in user payload.")
    }

    // Step 2: Get user profile using token
    const profileRes = yield call(
      API.get,
      "/users/profile",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    )

    const userDetails = profileRes.data.user

    // Save user to localStorage
    localStorage.setItem("user", JSON.stringify(userDetails))
    localStorage.setItem("fname", userDetails.fname || "")
    localStorage.setItem("lname", userDetails.lname || "")

    //  Only overwrite email if it's not already set or if userDetails has a valid email
    if (!localStorage.getItem("email") && userDetails?.email) {
      localStorage.setItem("email", userDetails.email)
    } else if (!userDetails?.email) {
      console.warn("userDetails.email is undefined — skipping overwrite")
    }

    // Dispatch login success
    yield put(loginSuccess(userDetails, token))

    // Callback to unlock
    if (callback) callback()

    // Navigate to dashboard
    const redirectPath =
      localStorage.getItem("redirectAfterLogin") || "/dashboard"
    localStorage.removeItem("redirectAfterLogin")
    history(redirectPath)

    // if (history) history("/dashboard")
  } catch (error) {
    let errorMessage = "Something went wrong. Please try again."
    if (error.response) {
      errorMessage = error.response.data.message || errorMessage
    } else {
      errorMessage = error.message
    }
    console.error("Login saga error:", errorMessage)
    yield put(apiError(errorMessage))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authToken")
    localStorage.removeItem("email")
    localStorage.removeItem("user")

    yield put(logoutUserSuccess())
    history("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeLatest(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
